export default "__VITE_ASSET__CpOdqzj___"